import { connect } from 'react-redux';
import { fetchStock } from '../../store/actions/stock';
import SelectionStock from './SelectionStock';
import { userLogoutRequest } from '../../store/actions/user';

const mapStateToProps = ({ stockReducer, userReducer }) => ({
  stockReducer,
  userReducer
});
const mapDispatchToProps = {
  fetchStock,
  userLogoutRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectionStock);
